import { React, useEffect, useState } from 'react';
import { PAGE_ROUTE, API_URL } from '../../shared/constant';
import { NavLink, useNavigate } from 'react-router-dom';
import TableComponent from '../../shared/table';
import LoaderComponent from '../../shared/loader';
import axios from 'axios';

const QuotesList = () => {

    const [currentPage, setcurrentPage] = useState(1);
    const [isNext, setNext] = useState(false);
    const [isPrev, setPrev] = useState(false);

    const columns = [{
        field: 'title',
        lable: 'Title'
    },{
        field: 'text_mode',
        lable: 'Text Mode'
    }, {
        field: 'imageName',
        lable: 'Image',
    }];

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState('');
    const [categories, setCategories] = useState([]);

    const nextPage = () => {
        let page = currentPage + 1;
        setcurrentPage(page);
        getCategory(page);
    }

    const prevPage = () => {
        let page = currentPage - 1;
        setcurrentPage(page);
        getCategory(page);
    }

    useEffect(() => {
        getCategory(1);
        getCategories();
    }, []);

    useEffect(() => {
        isRecall && getCategory(currentPage);
    }, [isRecall]);

    const getCategory = (page, searchParam = search, categoryParam = category) => {
        setLoading(true);
        const payload = { page: page, search: searchParam, category_id: categoryParam };
        axios.post(API_URL.ADMIN_QUOTES_LIST, payload).then(res => {
            setData(res.data.data.data);
            if (res.data.data.next_page_url) {
                setNext(true)
            } else {
                setNext(false)
            }
            if (res.data.data.prev_page_url) {
                setPrev(true)
            } else {
                setPrev(false)
            }
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    };

    const getCategories = () => {
        axios.post(API_URL.ADMIN_QUOTES_CATEGORY_LIST).then(res => {
            setCategories(res.data.data || []);
        }).catch(err => {
            // ignore errors for now
        });
    };

    const onDelete = (item) => {
        let id = item.id;
        axios.post(API_URL.ADMIN_QUOTES_DELETE + id).then((response) => {
            setIsRecall(true);
        });
    };

    const handleSearchChange = (e) => {
        const val = e.target.value;
        setSearch(val);
        setcurrentPage(1);
    };

    const handleCategoryChange = (e) => {
        const val = e.target.value;
        setCategory(val);
        setcurrentPage(1);
    };

    const performSearch = () => {
        setcurrentPage(1);
        getCategory(1, search, category);
    };

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_QUOTES_EDIT + item.id, { replace: true });
    };

    const onInlineEdit = (item, field, value) => {
        const payload = {
            id: item.id,
            [field]: value
        };

        axios.post(API_URL.ADMIN_QUOTES_UPDATE, payload).then((response) => {
            // Update the local data with the new value
            const updatedData = data.map(quote => {
                if (quote.id === item.id) {
                    return { ...quote, [field]: value };
                }
                return quote;
            });
            setData(updatedData);
        }).catch((error) => {
            console.error('Error updating quote:', error);
            alert('Failed to update quote');
        });
    };

    return (
        <div className='card'>
            <div className='card-body'>
                <h4 className='card-title'>Quotes
                
                    <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-end">
                            <li>
                                <NavLink to={PAGE_ROUTE.ADMIN_QUOTES_CREATE} className="btn btn-outline-success btn-sm me-2">
                                    Add
                                </NavLink>
                            </li>
                            <li className="page-item disabled">
                                {isPrev ? <button className="btn btn-outline-primary btn-sm me-2" onClick={prevPage}>Previous</button> : ""}
                            </li>
                            <li className="page-item">
                                {isNext ? <button className="btn btn-outline-primary btn-sm" onClick={nextPage}>Next</button> : ""}
                            </li>
                        </ul>
                    </nav>
                </h4>

                {
                    isLoading && <LoaderComponent height={100} width={100}></LoaderComponent>
                }
                {
                    !isLoading && <div className="table-responsive">
                        <div className='row mb-3'>
                            <div className='col-md-6'>
                                <input name="search" value={search} onChange={handleSearchChange} className="form-control" placeholder="Search" />
                            </div>
                            <div className='col-md-4'>
                                <select name="category" value={category} onChange={handleCategoryChange} className="form-select">
                                    <option value="">All Categories</option>
                                    {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.title}</option>)}
                                </select>
                            </div>
                            <div className='col-md-2'>
                                <button type="button" className="btn btn-primary w-100" onClick={performSearch}>Search</button>
                            </div>
                        </div>
                        <div className='table-responsive'>
                            <TableComponent
                                columns={[...columns, { field: 'category_id', lable: 'Category' }]}
                                data={data}
                                onDelete={onDelete}
                                onEdit={onEdit}
                                inlineEditFields={['title', 'text_mode', 'category_id']}
                                onInlineEdit={onInlineEdit}
                                inlineSelectOptions={{ category_id: categories }}>
                            </TableComponent>
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-end">
                                <li className="page-item disabled">
                                    {isPrev ? <button className="btn btn-outline-primary btn-sm me-2" onClick={prevPage}>Previous</button> : ""}
                                </li>
                                <li className="page-item">
                                    {isNext ? <button className="btn btn-outline-primary btn-sm" onClick={nextPage}>Next</button> : ""}
                                </li>
                            </ul>
                        </nav>
                    </div>
                }
            </div>
        </div>
    )
}

export default QuotesList